import { gsap } from "gsap";

export class Lines {
  constructor() {
    this._lines = document.querySelectorAll(".line");
    this.init();
  }

  init() {
    if (!this._lines) return;

    this._lines.forEach((line, i) => {
      gsap.fromTo(
        line,
        { height: 0 },
        {
          height: "100%",
          duration: 1,
          ease: "power2.inOut",
          delay: i * 0.2,
        },
      );
    });
  }
}
